import React from "react";

/**
 * Lifespan Wealth Partners wordmark + small gold arc glyph.
 * Renders inline SVG so it scales crisply and matches brand colors.
 */
export const Logo = ({ variant = "navy", compact = false }) => {
  const wordColor = variant === "light" ? "#FAF8F3" : "#0B2545";
  const arcColor = "#D4A24C";

  return (
    <a
      href="/"
      data-testid="brand-logo"
      className="flex items-center gap-2.5 group"
      aria-label="Lifespan Wealth Partners home"
    >
      {/* Gold arc glyph */}
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        className="transition-transform duration-500 group-hover:rotate-[-8deg]"
      >
        <path
          d="M3 22 C 8 8, 24 8, 29 22"
          stroke={arcColor}
          strokeWidth="2.4"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="3" cy="22" r="2.4" fill={arcColor} />
        <circle cx="29" cy="22" r="2.4" fill={arcColor} />
        <circle cx="16" cy="9.6" r="1.6" fill={arcColor} />
      </svg>

      <div className="flex flex-col leading-none">
        <span
          className="font-serif-display text-[1.05rem] sm:text-[1.15rem] font-semibold tracking-tight"
          style={{ color: wordColor }}
        >
          Lifespan{!compact && " Wealth Partners"}
        </span>
        {!compact && (
          <span
            className="font-sans-ui text-[0.625rem] tracking-[0.22em] uppercase mt-0.5"
            style={{ color: variant === "light" ? "#D4A24C" : "#6B7280" }}
          >
            Est. 2026
          </span>
        )}
      </div>
    </a>
  );
};

export default Logo;
